import React, { useRef, useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Badge from "@mui/material/Badge";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/styles";

import axios from "axios";
const drawerWidth = 300;
const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  appBar: {
    position: "fixed",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  appBarBottom: {
    top: "auto",
    bottom: 0,
    [theme.breakpoints.up("sm")]: {},
  },
  grow: {
    flexGrow: 1,
  },
  productListPaper: {
    marginBottom: 50,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const materialTheme = createTheme({
  // set default for now
});

function SalesInvoiceProducts(props) {
  const classes = useStyles();
  const [products, setProducts] = useState([]);
  const [accountsLabel, setAccountLabel] = useState({});
  const [isLoadingAccountLabel, setIsLoadingAccountLabel] = useState(true);

  useEffect(() => {
    if (!isLoadingAccountLabel) {
      return;
    }

    const getAccountsLabel = () => {
      const options = {
        method: "POST",
        url: "/TransactiLabels/getTransactiLiteLabels.json",
      };

      axios(options)
        .then((res) => {
          const labels = res.data.response;
          const accountLabel = labels.accounts;
          const accountClassificationsLabel = labels.account_classifications;

          setAccountLabel(accountLabel);
          setIsLoadingAccountLabel(false);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    getAccountsLabel();
  }, [accountsLabel, isLoadingAccountLabel]);

  function productElement(product) {
    return (
      <Grid container>
        <Grid container item xs={12}>
          <Grid container direction="column" justifyContent="space-between" alignItems="stretch">
            <Grid item>
              <Box style={{ fontWeight: 600, fontSize: "14px" }}>{product.brand}</Box>
              <Box style={{ fontWeight: 600, fontSize: "14px" }}>{product.product_name}</Box>
            </Grid>
            <Grid item>
              <Box display="flex" justifyContent="flex-end">
                <Typography
                  variant="h6"
                  component="span"
                  style={{ fontWeight: 600, fontSize: "16px", color: "green" }}
                >
                  ₱{product.price_with_tax} x {product.quantity_invoiced} {product.uom} ={" "}
                  {Number(
                    (product.price_with_tax * product.quantity_invoiced).toFixed(2)
                  ).toLocaleString("en-US", { maximumFractionDigits: 2 })}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
  function productLists() {
    return (
      <List>
        {products.map((product) => (
          <React.Fragment key={product.id}>
            <ListItem>{productElement(product)}</ListItem>
            <Divider light />
          </React.Fragment>
        ))}
      </List>
    );
  }

  function accountInformation() {
    if (typeof props.selectedInvoice !== "undefined") {
      return (
        <Typography gutterBottom variant="subtitle1">
          {Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural} name :{" "}
          {props.selectedInvoice.account_name}
          <br />
          {Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural} code :{" "}
          {props.selectedInvoice.account_code}
        </Typography>
      );
    }
  }
  function salesOrderInformations() {
    return (
      <Grid container style={{ padding: "1rem" }}>
        <Grid item xs={12} sm container>
          <Grid item xs container direction="column" spacing={2}>
            <Grid item xs>
              {accountInformation()}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  function computeTotalSalesInvoiceAmount() {
    if (props.selectedInvoice === null || props.selectedInvoice === undefined) {
      return 0;
    }

    const totalInvoicedValue = Number(
      props.selectedInvoice.InvoiceItems.reduce((partialSum, product) => {
        return partialSum + product.price_with_tax * product.quantity_invoiced;
      }, 0)
    );

    return totalInvoicedValue;
  }
  useEffect(() => {
    if (props.selectedInvoice === null || props.selectedInvoice === undefined) {
      return;
    }
    setProducts(props.selectedInvoice.InvoiceItems);
  });
  return (
    <div>
      <Dialog
        fullScreen
        open={props.openSaleOrderProductDialog}
        onClose={() => {
          props.setOpenSaleOrderProductDialog(false);
        }}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => {
                props.setOpenSaleOrderProductDialog(false);
              }}
              size="large"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="subtitle1" className={classes.title}>
              Transacti Receive Products
            </Typography>
          </Toolbar>
        </AppBar>
        <div className={classes.appBarSpacer}></div>
        <Paper square className={classes.productListPaper}>
          {salesOrderInformations()}
          {productLists()}
        </Paper>
        <AppBar position="fixed" color="primary" className={classes.appBarBottom}>
          <Toolbar>
            <div className={classes.grow} />

            <Typography
              variant="h6"
              noWrap
              component="span"
              style={{ fontWeight: 600, fontSize: "16px" }}
            >
              Total: ₱
              {Number(computeTotalSalesInvoiceAmount().toFixed(2)).toLocaleString("en-US", {
                minimumFractionDigits: 2,
              })}
            </Typography>
          </Toolbar>
        </AppBar>
      </Dialog>
    </div>
  );
}

export default SalesInvoiceProducts;
